/** @file Guesses the Mod-key platform (mac vs win vs linux) from a navigator-like object. */
import type { Platform } from './types';

/** `mac` for macOS/iOS (also Node's `darwin`), `win` for Windows, otherwise `linux`; `undefined` gives `linux`. */
export function detectPlatform(nav: { platform?: string; userAgent?: string } | undefined): Platform {
  const text = `${nav?.platform ?? ''} ${nav?.userAgent ?? ''}`;
  if (/mac|darwin|iphone|ipad|ipod/i.test(text)) return 'mac';
  return /win/i.test(text) ? 'win' : 'linux';
}
